// extracted by mini-css-extract-plugin
export default {"subproductTitle":"atBJgzT8DPiD_FGwUMhNQU5FCsAtjbgR","subproductQuantity":"TXjlcD9FsoxmW05dOBK4wltPjByMfnUW","subproductName":"RkZPspGptOmF3CyDpyyHQ4DafrPMIb7b"};